import { Component, OnInit } from '@angular/core';
import { gapFormUrl } from '../../../shared/form-url';

@Component({
  selector: 'app-what-is-gap',
  templateUrl: './what-is-gap.component.html',
  styleUrls: ['./what-is-gap.component.scss'],
})
export class WhatIsGapComponent implements OnInit {
  readonly formUrl = gapFormUrl;
  constructor() {}

  ngOnInit(): void {}

  scrollToBenefits(): void {
    const element = document.querySelector('.benefits__videoTab');
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 100;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }
}
